export const inputClassName = 'crm-input';

export const labelClassName = 'crm-label';

export const panelClassName = 'crm-panel';

export const tableHeadClassName = 'crm-table-head';

export const tableCellClassName = 'crm-table-cell';

export const primaryButtonClassName = 'crm-btn-primary';

export const secondaryButtonClassName = 'crm-btn-secondary';

export const linkClassName = 'crm-link';
